/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../../common/components/ag-grid-react-component';
import PropTypes from 'prop-types';
import React from 'react';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

function colDefsTransaction ( param ) {
   
const colDefs = [
    {
        field: 'transId',
        headerName: 'ID',
        sortable: true,
        filter: true,
        width: 60
    },
    {
        field: 'transDateString',
        headerName: 'Date',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'transTimeString',
        headerName: 'Time',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'activityType',
        headerName: 'ACT',
        sortable: true,
        filter: true,
        width: 60
    },
    {
        field: 'dealerRespCode',
        headerName: 'DRC',
        sortable: true,
        filter: true,
        width: 60
    },
    {
        field: 'factoryRespCode',
        headerName: 'FRC',
        sortable: true,
        filter: true,
        width: 60
    },
    {
        field: 'orderNumber',
        headerName: 'Order',
        sortable: true,
        filter: true,
        width: 80,
        cellRenderer: params => {

            if ( params.value === 0 || params.value === '' ) return ( <span>{params.value}</span> );
                return (
                    <span
                        className="order-number-link"
                        onClick={() => param.onSelectOrderNumber( params.value, params.data.transId )
                        }
                    >{params.value}
                    </span>
                );

        }
    },
    {
        field: 'reqDeliveryDateString',
        headerName: 'RDD',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'buildWeekString',
        headerName: 'Build Week',
        sortable: true,
        filter: true,
        width: 100
    },
    {
        field: 'model',
        headerName: 'Model',
        sortable: true,
        filter: true,
        width: 70
    },
    {
        field: 'retailInd',
        headerName: 'Ret Ind',
        sortable: true,
        filter: true,
        width: 70
    },
    {
        field: 'errText',
        headerName: 'Message',
        sortable: true,
        filter: true,
        width: 100
    }
];
    return colDefs;

}

function colDefsReallocation ( param ) {

const colDefsRealloc = [
    {
        field: 'transId',
        headerName: 'ID',
        sortable: true,
        filter: true,
        width: 60
    },
    {
        field: 'transDateString',
        headerName: 'Date',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'transTimeString',
        headerName: 'Time',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'activityType',
        headerName: 'ACT',
        sortable: true,
        filter: true,
        width: 60
    },
    {
        field: 'dealerRespCode',
        headerName: 'DRC',
        sortable: true,
        filter: true,
        width: 60
    },
    {
        field: 'factoryRespCode',
        headerName: 'FRC',
        sortable: true,
        filter: true,
        width: 60
    },
    {
        field: 'orderNumber',
        headerName: 'Order',
        sortable: true,
        filter: true,
        width: 80,
        cellRenderer: params => {

            if ( params.value === 0 || params.value === '' ) return ( <span>{params.value}</span> );
                return ( <span className="order-number-link" onClick={() => param.onSelectOrderNumber( params.value )}>{params.value}</span> );

        }
    },
    {
        field: 'orgExpectedWarehouseDateString',
        headerName: 'Original Expected Warehouse Date',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'expectedWarehouseDateString',
        headerName: 'Expected Warehouse Date',
        sortable: true,
        filter: true,
        width: 100
    },
    {
        field: 'model',
        headerName: 'Model',
        sortable: true,
        filter: true,
        width: 70
    },
    {
        field: 'retailInd',
        headerName: 'Ret Ind',
        sortable: true,
        filter: true,
        width: 70
    },
    {
        field: 'errText',
        headerName: 'Message',
        sortable: true,
        filter: true,
        width: 100
    }
];

    return colDefsRealloc;

}

const colDefsAtpTrx = [
    {
        field: 'updatedDateString',
        headerName: 'Date',
        sortable: true,
        filter: true,
        width: 140
    },
    {
        field: 'transTimeString',
        headerName: 'Time',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'act',
        headerName: 'ACT',
        sortable: true,
        filter: true,
        width: 60
    },
    {
        field: 'drc',
        headerName: 'DRC',
        sortable: true,
        filter: true,
        width: 60
    },
    {
        field: 'frc',
        headerName: 'FRC',
        sortable: true,
        filter: true,
        width: 60
    },
    {
        field: 'order',
        headerName: 'Order',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'originalOrder',
        headerName: 'Original Order',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'rddString',
        headerName: 'RDD',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'buildWeekString',
        headerName: 'Build Week',
        sortable: true,
        filter: true,
        width: 90
    },
    {
        field: 'baseMach',
        headerName: 'Base Machine',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'family',
        headerName: 'Family',
        sortable: true,
        filter: true,
        width: 80
    },
    {
        field: 'retInd',
        headerName: 'Ret Ind',
        sortable: true,
        filter: true,
        width: 60
    },
    {
        field: 'message',
        headerName: 'Message',
        sortable: true,
        filter: true,
        width: 100
    }
];
const TransactionReallocationLogTable = props => {

    let colDef = props.transactionLog ? colDefsTransaction( props ) : colDefsReallocation( props );
    colDef = props.deereAtp ? colDefsAtpTrx : colDef;
    const count = props.results.length;
    const message = count ? `${count} Results found at ${new Date()}` : '';

    return (

        <section className="atp-search-result-panel transaction-reallocation-log-result-panel">

            <div className="results-message">
                {message}
            </div>

            <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
                <AgGridReactComponent
                    reactNext={true}
                    columnDefs={colDef}
                    rowData={props.results}
                    onGridReady={onGridReady}
                    onSelectOrderNumber={props.onSelectOrderNumber}
                />
            </div>

        </section>
    );

};

TransactionReallocationLogTable.propTypes = {
    results: PropTypes.array.isRequired,
    transactionLog: PropTypes.bool,
    deereAtp: PropTypes.bool,
    onSelectOrderNumber: PropTypes.func.isRequired
};
export default TransactionReallocationLogTable;
